<!-- Translated: skip -->
<template>
  <div class="unit-group-listing">
    <transition name="animate-filter">
      <div v-if="!expanded" @click.stop="isManuallyExpanded = true" class="collapsed">
        <div class="text">
          <button class="expanding-button" v-if="unitCount > 1">Visa alla {{ unitCount }} boendealternativ</button>
          <button class="expanding-button" v-if="unitCount === 1">Visa {{ unitCount }} boendealternativ</button>
        </div>
        <div class="button">
          <icon name="chevron-down-white" />
        </div>
      </div>
    </transition>
    <transition name="animate-filter">
      <div v-if="expanded" class="expanded">
        <div @click.stop="isManuallyExpanded = false" class="header" v-if="!$store.state.accomodationsFilter.freeSearch">
          <div class="text">Stäng</div>
          <div class="button">
            <icon name="chevron-up" />
          </div>
        </div>
        <div class="body">

          <div v-for="(group, index) in groupedUnits" :class="{ odd: index % 2 }" class="animate-pool-list-item" :key="group.key">
            <AccomodationsListUnitsList :units="group.units" :grouping="group.title" />
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import OutlineButton from '@/components/components/OutlineButton';
import TableSortIndicator from '@/components/components/TableSortIndicator';
import AccomodationsListUnitsList from '@/components/parts/Accomodation/List/AccomodationsListUnitsList';
import {
  filter,
} from 'lodash/fp';
import {
  filterUnit,
} from '@/lib';

import moment from 'moment';

export default {
  props: ['pool'],
  components: {
    OutlineButton,
    TableSortIndicator,
    AccomodationsListUnitsList,
  },
  data() {
    return {
      sortColumn: null,
      sortReverse: false,
      isManuallyExpanded: false,
    };
  },
  mounted() {
    if (this.$store.state.accomodationsFilter.locationId) {
      this.expanded = true;
    }
  },
  computed: {
    filteredUnits() {
      const unitFilter = filterUnit(this.$store.state.accomodationsFilter);
      return filter(unitFilter, this.pool.units);
    },
    groupedUnits() {
      const groups = [];
      let key = 1;

      const bedGrouping = [4, 6, 8, 10, 12];

      const groupType = this.SITE_CONFIG.accomodations.display_as_group_pools[this.pool.id];

      if (groupType === 'floor') {
        this.filteredUnits.forEach((unit) => {
          key += 1;

          const object = {
            title: unit.floor ? unit.floor.value : '',
            sorting: unit.floor ? unit.floor.value : 0,
            key,
            units: [unit],
          };

          let matchingIndex = false;

          const title = unit.floor ? unit.floor.value : '';

          groups.forEach((group, index) => {
            if (title === group.title) {
              matchingIndex = index;
            }
          });

          if (matchingIndex === false) {
            groups.push(object);
          } else {
            groups[matchingIndex].units.push(unit);
          }
        });
      } else {
        this.filteredUnits.forEach((unit) => {
          let title = '';
          let sorting = '';
          const subtitle = unit.subtitle || '';
          let capacity = unit.beds;

          // Exceptions
          if (unit.unit_lid === 10021) {
            capacity = 4;
          }

          let capacityTitle = '';

          if (capacity < bedGrouping[0]) {
            capacityTitle = `<${bedGrouping[0]} bäddar`;
          } else if (capacity >= bedGrouping[bedGrouping.length - 1]) {
            capacityTitle = `${bedGrouping[bedGrouping.length - 1]}+ bäddar`;
          } else {
            /*eslint-disable */
            for (const i in bedGrouping) {
              let ii = parseInt(i, 10);
              if (capacity >= bedGrouping[ii]) {
                let next = bedGrouping[ii + 1];
                capacityTitle = `${bedGrouping[ii]}–${next} bäddar`;
              }
            }
            /*eslint-enable */
          }

          // What a hack, but it works
          if (subtitle.toLowerCase().match(/förhöjd standard/)) {
            title = 'Förhöjd standard, ';
            sorting = 100 + capacity;
          } else {
            sorting = 200 + capacity;
          }

          title = `${title}${capacityTitle}`;

          key += 1;

          const object = {
            title,
            sorting,
            key,
            units: [unit],
          };

          let matchingIndex = false;

          groups.forEach((group, index) => {
            if (title === group.title) {
              matchingIndex = index;
            }
          });

          if (matchingIndex === false) {
            groups.push(object);
          } else {
            groups[matchingIndex].units.push(unit);
          }
        });
      }

      const sortedGroups = groups.sort((a, b) => {
        if (a.sorting > b.sorting) {
          return 1;
        } else if (a.sorting < b.sorting) {
          return -1;
        }
        return 0;
      });

      return sortedGroups;
    },
    unitCount() {
      return this.filteredUnits.length;
    },
    expanded() {
      if (this.$store.state.accomodationsFilter.freeSearch) {
        return true;
      }
      return this.isManuallyExpanded;
    },
    ...mapGetters([
      'favoriteAccommodations',
    ]),
  },
  methods: {
    getPrice(id) {
      if (window.prices) {
        return window.prices[id].price;
      }

      return null;
    },
    isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    sort(column) {
      if (this.sortColumn === column) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortColumn = column;
        this.sortReverse = false;
      }
    },
    moment(d) {
      return moment(d);
    },
    isSorted(column) {
      /* eslint-disable no-nested-ternary */
      return (
        this.sortColumn === column
        ? (
          this.sortReverse
          ? -1
          : 1
        )
        : 0
      );
    },
    openPriceList(unit) {
      this.$router.push({ path: `/boenden/pris/${unit.slug}?flow=boenden` });
    },
    openInfo(unit) {
      let image = '';
      if (this.$store.state.accomodationView && this.$store.state.accomodationView) {
        image = '/bilder';
      }

      if (this.$store.state.accomodationsFilter.date.endDate) {
        const arrival = moment(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
        const departure = moment(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
        this.$router.push({ path: `/boenden${image}/info/${unit.slug}/${arrival}/${departure}?flow=boenden` });
      } else {
        this.$router.push({ path: `/boenden${image}/info/${unit.slug}?flow=boenden` });
      }
    },
    ...mapMutations([
      'accomodationPeriodPick',
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addFavorite',
      'removeFavorite',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.unit-group-listing
  +max-mobile()
    padding-left 0px
    padding-right 0px

.outline-button
  button-reset()
  display: inline-block
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 0.4rem 0.4rem 0.2rem 0.4rem
  line-height 1em
  font-weight bold
  font-size 11px
  transition-ease()
  &.price-info-bt
    min-width: auto
    padding: 0.4rem 0.4rem 0.3rem 0.4rem;
    +max-mobile()
      max-width: 160px
      min-width: 40%
      float: right;

  &:hover
    border-color alpha(deep-blue, .5)
    border-bottom-width: 1px
    background-color: light-blue-grey
    color #005580
  &:focus
    outline none
    border-color deep-blue
  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white
  &.has-text
    .icon
      position: relative;
      top: -2px
      margin-right: 5px

.component
  transition-slide('animate-filter')
  padding: 5px 6px

.collapsed
  background-color pale-sky
  border-radius 0 0 3px 3px
  height 45px
  display flex
  align-items center
  cursor pointer

  .text
    color deep-blue
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
  .button
    background deep-blue
    color white
    width 45px
    align-self stretch
    border-radius 0px
    position relative
    border: 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%




.expanded
  .header
    background-color deep-blue
    color white
    height 45px
    display flex
    align-items center
    cursor pointer
    position relative
    z-index 0
  .text
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
    text-transform uppercase
    letter-spacing letter-spacing-uppercase
  .button
    background pale-sky
    color deep-blue
    width 45px
    align-self stretch
    border-radius 0px
    position: relative;
    border 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%
  .body

    shadow()
    table
      border-collapse collapse
      width 100%
      thead
        background-color alpha(deep-blue, .85)
        color white
      tbody
        background-color white
        border-top 0
        th
          i
            font-style normal
            font-weight 300
            display block
            color greyish-brown
            margin-top 2px
            font-size 95%
        &.animate-pool-list
          transition-list('animate-pool-list')

      tbody
        tr
          cursor pointer
          &.odd
            background-color pale-sky
          &:hover
            background-color #deebf0

      th, td
        padding 10px space-2
        font-size 90%
        +max-tablet()
          padding 10px space-1
        white-space nowrap
        line-height 1.25em
        &.wrap
          white-space normal
        &.no-padding
          padding-left 0
          padding-right 0
      +max-mobile()
        th,
        td
          width 100%
          display block
          padding 5px 15px 5px
          &.min-tablet
            display none
      th.sortable
        cursor pointer
      .actions
        text-align right
        b
          font-size: 13px;
          font-weight: bold;
          letter-spacing: 0.2px;
          color: #262626;
          line-height 28px
          display inline-block
        & > div
          display flex
          margin -5px
          & > *
            margin 5px

.favorite-icon-wrapper
  background-color white
  border 1px solid #bfd9e1
  border-radius 4px
  font-size 25px
  display: inline-block
  padding 0
  background-repeat: no-repeat;
  background-position: center
  background-image url(https://static.booking.branasgruppen.se/static/svg/heart.svg)
  background-size 70%
  height 28px
  width 28px
  cursor pointer
  &:hover
    opacity 0.8
  &.active
    background-image url(https://static.booking.branasgruppen.se/static/svg/heart-red.svg)
.unit-title
  b
    float right

.facts
  +max-mobile()
    display flex !important
    flex-wrap wrap
    & > div
      width 50%
.the-price
  +max-mobile()
    display none !important

.animate-pool-list-item
  padding: 8px 8px 0 8px
  background-color pale-sky
  &:last-child
    padding-bottom 8px

.expanding-button
  util-reset-button()
</style>



// WEBPACK FOOTER //
// AccomodationsListUnitsGroup.vue?2bd97996